export interface SubtotalGuardConfig<T> {
	isSubtotalKey: keyof T;
	typeKey: string; // keyof T가 아닌 문자열로 허용 (유니온 키 교집합 문제 회피)
	itemTypeValue: string;
	dateTypeValue: string;
}

export const createSubtotalGuards = <T extends Record<string, any>>(config: SubtotalGuardConfig<T>) => {
	const { isSubtotalKey, typeKey, itemTypeValue, dateTypeValue } = config;

	const isSubtotalRow = (row: T): boolean => {
		return Boolean(row?.[isSubtotalKey] === true);
	};

	const isItemSubtotalRow = (row: T): boolean => {
		return isSubtotalRow(row) && row?.[typeKey] === itemTypeValue;
	};

	const isDateSubtotalRow = (row: T): boolean => {
		return isSubtotalRow(row) && row?.[typeKey] === dateTypeValue;
	};

	return { isSubtotalRow, isItemSubtotalRow, isDateSubtotalRow };
};
